import { authenticatedApi } from '../../../shared/api/apiClientUtils.ts';
import type {
  CreateLabourItemRequest,
  CreateLabourItemResponse,
  SearchLabourDefinitionsResponse,
  LabourItemDefinitionSummary,
} from '../types/labourItemTypes.ts';

export interface CreateLabourItemDefinitionRequest {
  name: string;
}

export interface LabourItemDefinition {
  id: string;
  name: string;
  groupCount: number;
}

export const createLabourItemDefinition = async (
  request: CreateLabourItemDefinitionRequest
): Promise<void> => {
  await authenticatedApi.post('/api/v1/labour-items/definitions', request);
};

export const getLabourItemDefinitions = async (): Promise<
  LabourItemDefinition[]
> => {
  const response = await authenticatedApi.get<LabourItemDefinition[]>(
    '/api/v1/labour-items/definitions'
  );
  return response.data;
};

export const deleteLabourItemDefinition = async (id: string): Promise<void> => {
  await authenticatedApi.delete(`/api/v1/labour-items/definitions/${id}`);
};

export const searchLabourDefinitions = async (
  searchTerm: string,
  signal?: AbortSignal
): Promise<SearchLabourDefinitionsResponse> => {
  const response = await authenticatedApi.get<LabourItemDefinitionSummary[]>(
    '/api/v1/labour-items/definitions',
    {
      params: { search: searchTerm },
      signal,
    }
  );

  const definitions = response.data || [];
  return {
    definitions,
    totalCount: definitions.length,
  };
};

export const createLabourItem = async (
  siteId: number,
  plotId: number,
  request: CreateLabourItemRequest
): Promise<CreateLabourItemResponse> => {
  const response = await authenticatedApi.post<CreateLabourItemResponse>(
    `/api/v1/sites/${siteId}/plots/${plotId}/labour-items`,
    request
  );
  return response.data;
};
